import { render, staticRenderFns } from "./InternetConnection.vue?vue&type=template&id=7b4f2a1b&scoped=true&"
import script from "./InternetConnection.vue?vue&type=script&lang=ts&"
export * from "./InternetConnection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4f2a1b",
  null
  
)

export default component.exports